import weatherConditionMap from "./weatherConditionMap";

/**
 * Robustere Mapping-Funktion:
 * durchsucht den Zustandstext und prüft, ob ein Schlüssel enthalten ist
 */
export function getMappedCondition(rawText) {
  const normalized = rawText.trim().toLowerCase();

  for (const [key, mappedValue] of Object.entries(weatherConditionMap)) {
    if (normalized.includes(key)) {
      return mappedValue;
    }
  }

  console.warn(`⚠️ Kein passendes Mapping für: "${rawText}"`);
  return rawText; // fallback zur Anzeige
}
